import React from 'react';
import { useTheme } from '../../../../theme-context';
import { classNames } from '../../../../utils/classNames';

interface IKpiBox {
    color: string;
    title: string;
    total: string | number;
    percentage: string | number;
	status: string,
	showUnanswered: ()=>void
}

const KpiBox = ({
    color,
    title,
    total,
    percentage,
	status,
	showUnanswered
}: IKpiBox) => {
    const { theme } = useTheme();

    const formatTitle = (input: any) => {
        return input
            .replace(/-/g, ' ')
            .split(' ')
            .map((word: any) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase())
            .join(' ');
    }

    const formatNumber = (value: number | string) => {
        const number = typeof value === 'string' ? parseFloat(value) : value;

        if (isNaN(number)) return 'Invalid';

        if (number < 1000) {
            return number.toString();
        } else if (number < 10000) {
            return number.toLocaleString();
        } else if (number < 1_000_000) {
            return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        } else if (number < 1_000_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
        } else {
            return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
        }
    }

	const handleClickBox = () => {
		if (status === 'unanswerable')
			showUnanswered()
	}
    const percentageFormat = percentage ? typeof percentage === 'string' ? parseFloat(percentage) : percentage || 0 : 0;
    return (
        <div className={classNames(`border-2 ${color} !rounded-lg p-3`, status === 'unanswerable' ? 'cursor-pointer' : '')} onClick={handleClickBox}>
            <p className='mb-2 dark:text-primary-dark'>{formatTitle(title)}</p>
            <div className='flex flex-row items-center justify-between'>
                <p className='dark:text-primary-dark'>{formatNumber(total || 0)}</p>
                <div className='flex flex-row items-center'>
                    <p className='text-sm mr-2 dark:text-primary-dark'>{percentageFormat?.toFixed(2)}%</p>
                    {percentageFormat < 0 && <img src={theme === 'dark' ? '/assets/insights/down-arrow-white.svg' : '/assets/insights/down-arrow.svg'} className='object-contain w-[17px]' />}
                    {percentageFormat > 0 && <img src={theme === 'dark' ? '/assets/insights/growing-arrow-white.svg' : '/assets/insights/growing-arrow.svg'} className='object-contain w-[17px]' />}
                </div>
            </div>
        </div>
    )
}

export default KpiBox;